export default {
      id: "head__logo-usage",
      viewBox: "0 0 184 40",
      url: __webpack_public_path__ + "img/icons.svg#head__logo",
      toString: function () {
        return this.url;
      }
    }